import React, {useState} from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./reset-password-form.scss";
import { toast } from "react-toastify";
import { authErrorToMessage } from "../errorMessages";
import request from "../../../utils/useApi";
import { Input, Button } from "antd";
import { SendOutlined } from "@ant-design/icons";

const ResetPasswordForm = ({onResetPasswordSuccess}) => {
  const [isSendingOtp, setIsSendingOtp] = useState(false);

  async function onSendOtp() {
    setIsSendingOtp(true);
    try {
      await request.post('/auth/forgetPassword' ,{'email': formik.values.email});
      toast.success("Send OTP email successfully");
    } catch (err) {
      toast.error("Send OTP email failed");
    } finally {
      setIsSendingOtp(false);
    }
  }

  const formik = useFormik({
    initialValues: {
      email: "",
      otp: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .trim()
        .email("Invalid email address")
        .required("Email is required"),
      otp: Yup.string().required("OTP is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .required("Confirm Password is required")
        .oneOf([Yup.ref("password"), null], "Passwords do not match"),
    }),
    onSubmit: async (values) => {
      try {
        let response = await request.post('/auth/resetPassword', {'email': values.email, 'otp': values.otp, 'newPassword': values.password});
        if (response.status === 200) {
          toast.success("Reset password successfully!");
          onResetPasswordSuccess();
        }
      } catch (error) {
        console.error("Reset password error:", error);

        const apiMsg = error?.response?.data?.message;
        const fbMsg = authErrorToMessage(error?.code);

        toast.error(apiMsg || fbMsg || "Reset password failed. Please try again.");
      }
    },
  });

  return (
    <div className="reset-password-section">
      <form onSubmit={formik.handleSubmit} className="reset-password-form">
        <div className="heading">
          <h2>Reset Password</h2>
          <p>Just a few taps to take off!</p>
        </div>

        <div className="email-input-wrap">
          <label>Email</label>
          {/* <input
            type="email"
            name="email"
            placeholder="Enter email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
 */}

          <Input
            placeholder="Enter email"
            type="email"
            name="email"
            autoComplete="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            suffix={
              <Button
                type="text"
                icon={
                  isSendingOtp ? (
                    <SendOutlined />
                  ) : (
                    <SendOutlined />
                  )
                }
                style={{width: 37, height: 37}}
                loading={isSendingOtp}
                disabled={formik.errors.email || isSendingOtp}
                onClick={onSendOtp}
                aria-label="Send OTP"
              />
            }
          /> 
          {formik.touched.email && formik.errors.email && (
            <div className="error">{formik.errors.email}</div>
          )}
        </div>

        <div className="input-wrap">
          <label>OTP</label>
          <input
            type="text"
            name="otp"
            placeholder="Enter OTP"
            value={formik.values.otp}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.otp && formik.errors.otp && (
            <div className="error">{formik.errors.otp}</div>
          )}
        </div>

        <div className="input-wrap">
          <label>New Password</label>
          <input
            type="password"
            name="password"
            placeholder="Enter a new password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.password && formik.errors.password && (
            <div className="error">{formik.errors.password}</div>
          )}
        </div>

        <div className="input-wrap">
          <label>Confirm New Password</label>
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm the new password"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.confirmPassword && formik.errors.confirmPassword && (
            <div className="error">{formik.errors.confirmPassword}</div>
          )}
        </div>

        <button className="custom-btn" type="submit">
          Reset Password
        </button>
      </form>
    </div>
  );
};

export default ResetPasswordForm;
